<template>
            <div class="content">
              <div class="row ">
                <div class="col-1"></div>
                <div class="col ">
                  <div class="card card-user">
              <div class="card-header">
                <h5 class="card-title">YENİ GÖRÜŞME KAYDI</h5>
              </div>
              <div class="card-body">
                <form @submit.prevent="onSubmit">

                   <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Tarih</label>
                        <input v-model="surec.tarih" type="date" class="form-control" placeholder="Tarih" >
                      </div>
                    </div>      
                  </div>

                    <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Firma Adı</label>
                        <input v-model="surec.firmaAdi" @input="surec.firmaAdi=surec.firmaAdi.toUpperCase()" type="text" class="form-control" placeholder="Firma Adı" >
                      </div>
                    </div>      
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Sektör</label>
                        <input v-model="surec.sektor" type="text" class="form-control" placeholder="Sektör" >
                      </div>
                    </div>      
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Görüşen Personel</label>
                        <input v-model="surec.gorusen" type="text" class="form-control" placeholder="Görüşen" >
                      </div>
                    </div>      
                  </div>

                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>Telefon</label>
                        <input v-model="surec.telefon" type="text" class="form-control" placeholder="0(500) XXX XX XX" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>E Posta</label>
                        <input v-model="surec.email" type="text" class="form-control" placeholder="E Posta" >
                      </div>
                    </div>
                  </div>

                  
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Süreç Durumu</label>
                        <p></p>
                        <textarea v-model="surec.surecDurumu" class="form-control textarea"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="update ml-auto mr-auto">
                      <button @click="goToBack"  class="btn btn-warning btn-round">Vazgeç</button>
                      <button @click="saveSurec" class="btn btn-success btn-round">Kaydet</button>
                    </div>
                  </div>
                </form>
              </div>
              
            </div>
                </div>
                <div class="col-1"></div>
              </div>

          <div class="loading2" :style="isLoading">
        <div class="lds-ripple2">
            <div> </div>
            <div> </div>
          </div>  
      </div>

            </div>
</template>

<script>
export default {
    data (){
      return{
        surec : {
          tarih : "",
          firmaAdi : "",
          sektor : "",
          gorusen : "",
          telefon : "",
          email : "",
          surecDurumu : "",

        },
        buttonClicked : false
      }
    },
    methods : {
      saveSurec(){
        this.$store.dispatch("saveSurec", this.surec);
        this.goToBack();
      },
      goToBack(){
        this.buttonClicked = true
        this.$router.push("/process")
      }
    },
    computed : {
     isLoading(){
       if(this.buttonClicked){
         return{
           display : "block"
         }
       }else{
         return{
           display : "none"
       }

     }
   },
   },
}
</script>




// WEBPACK FOOTER //
// src/components/process/ProcessNew.vue